var EN_TRANSLATION = {
  "Select Language": "Select Language"
};
export { EN_TRANSLATION as default };
//# sourceMappingURL=en.json.mjs.map
